'use strict';

import { GLOBAL } from './Global';
import { INSIGHT as INSIGHT_PERMISSION_GROUPS } from '../PermissionsGroups';

const insight_permissions_list = [];

for (const [key, value] of Object.entries(INSIGHT_PERMISSION_GROUPS)) {
  insight_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const INSIGHT = {
  can: [
    ...GLOBAL.can,
    ...insight_permissions_list,
  ],
};

export {
  INSIGHT,
};
